import React from "react";
import { cn } from "../../utils/cn";

interface CardProps {
  title?: string;
  value?: string | number;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  title,
  value,
  subtitle,
  children,
  className,
}) => (
  <div className={cn("bg-white rounded-xl shadow-sm border p-5", className)}>
    {title && <h3 className="text-sm text-gray-500">{title}</h3>}
    {value && <p className="text-2xl font-bold mt-1">{value}</p>}
    {subtitle && <p className="text-xs text-gray-400">{subtitle}</p>}
    {children}
  </div>
);

export default Card;
